import request from '@u/request'
/**
 * 重置接口
 * @param {*} data 
 */

// 测评结果列表
export function evaluationList(data){
	return request({
		url: '/cms_ceping/evaluationList',
		method: 'POST',
		data: data || {}
	})
}

// 全部测评
export function cepingAll(data){
	return request({
		url: '/cms_ceping/cepingAll',
		method: 'POST',
		data: data || {}
	})
}

// 重置测评
export function resetEvaluation(data){
	return request({
		url: '/cms_ceping/resetEvaluation',
		method: 'POST',
		data: data || {}
	})
}